<template>
    <div class="body" id="telemetering">
        <div class="header">
            <Area width="1473" @changeSite="changeSite" @initAreaId="getInitAreaId" />
        </div>
        <div class="search">
            <Search :count="total" :types="types" :classify="classify" @query="query" @filter="filter"></Search>
        </div>
        <div class="table">
            <Table :data="data" :classify="classify" :loadMoreStatus="accidentStatusMore"
                :tableInitStatus="tableInitStatus" @showDetail="showDetail" @setCheck="setCheck" @loadMore="loadMore">
            </Table>
        </div>
        <Details v-if="isShowDetail" :dialogVisible="isShowDetail" :status="accidentDetailStatus" :detail="detail"
            @closeDetail="closeDetail" />
    </div>
</template>

<script>
    import Area from '../../components/OperatingEnvironment/Area';
    import Search from '../../components/accidentManagement/Search';
    import Table from '../../components/accidentManagement/Table';
    import Details from '../../components/accidentManagement/Details';

    import {
        GetDetailList,
        GetAccidentDetailForId,
        GetAccidentValue,
        SetAccidentCheck,
    } from '../../api/accident';

    import {
        arrayUnique
    } from '../../util/Utils';

    // 每个事件种类下可选择的事件类型
    const ALARM_TYPE = {
        // 越限异常
        TELEMETRY_OVERRUN: ['过流', '欠流', '低温', '高温', '欠压', '过压', '重载'],
        // 网关离线
        EQUIPMENT_FAILURE: ['网关离线'],
        // 跳闸报警
        TELEMETRY_DISPLACEMENT: ['合闸', '分闸'],
        // 设备故障
        DEVICE_EXCEPTION: [],
        DEVICE_FAILURE: ['故障'],
    };

    export default {
        data() {
            return {
                all: '',
                // 表格数据
                data: [],
                // 是否显示详情页
                isShowDetail: false,
                // 报警总数
                total: 0,
                // 开始时间
                start: '',
                // 结束时间
                end: '',
                // 当前页
                currentPage: 1,
                // status: loading | loaded | error
                accidentDetailStatus: 'loaded',
                // 数据加载更多状态: loading | loaded | nomore
                accidentStatusMore: 'loaded',
                // table初始化状态: loading | loaded | error
                tableInitStatus: 'loaded',
                // 回路Id
                areaId: -1,
                // 事件类型
                eventType: '',
                // 详情页数据
                detail: {},
            }
        },
        components: {
            Search,
            Table,
            Area,
            Details
        },
        methods: {
            // 时间改变
            async query(dateRange) {
                // console.log('触发一次query', dateRange);
                this.start = dateRange ? new Date(dateRange[0]).toLocaleDateString() : '';
                this.end = dateRange ? new Date(dateRange[1]).toLocaleDateString() : '';
                // console.log(`start: ${this.start}, end: ${this.end}`);
            },
            // 报警类型改变
            filter(type) {
                //console.log('触发一次filter', type);
                this.eventType = type;
            },
            // 显示详情页
            async showDetail(code) {
                this.accidentDetailStatus = 'loading';
                this.isShowDetail = true;

                this.detail = await this.getAccidentDetail(code);
                // console.log(this.detail, code)
                if (this.detail == null) {
                    this.accidentDetailStatus = 'error';
                }

                this.accidentDetailStatus = 'loaded';
            },
            // 关闭详情页
            async closeDetail(id, state, change) {
                this.isShowDetail = false;
                if (state && change) {
                    let response = await SetAccidentCheck([id]);
                    if (response.data.code === 200 && response.data.status === true && response.data.msg ===
                        '状态更新成功') {
                        let index = this.data.findIndex(item => item.code == id)
                        this.$set(this.data[index], 'check', true)
                        return true;
                    }
                    return false;
                }
            },
            async setCheck(id) {
                let response = await SetAccidentCheck([id]);
                if (response.data.code === 200 && response.data.status === true && response.data.msg === '状态更新成功') {
                    let index = this.data.findIndex(item => item.code == id)
                    this.$set(this.data[index], 'check', true)
                    return true;
                }
                return false;
            },
            // 站点改变
            async changeSite(areaId) {
                //console.log('选择站点：', areaId);
                this.areaId = areaId;
            },
            // 初始获取站点
            async getInitAreaId(areaId) {
                this.areaId = areaId;
            },
            // 判断状态码 取出data
            transformForData(response) {
                const {
                    code,
                    data,
                    status
                } = response.data;
                if (code !== 200 && status !== true) {
                    console.error('response error: code is not 200 or status is not true');
                    return null;
                }

                return data;
            },
            // Mapper到详情页的指定数据格式
            accidentDetailMapper(data) {
                return {
                    loopId: data.loop_id,
                    img: data.device_img,
                    name: data.loop_name,
                    deviceName: data.device_name,
                    position: data.area_name,
                    code: data.id,
                    classify: data.alarm_event_type,
                    type: data.alarm_type_desc,
                    start: data.start_time,
                    end: data.end_time,
                    description: data.alarm_type_desc,
                    node: data.node,
                    check: data.alarm_check,
                    realName: data.real_name,
                    event_name: data.event_name,
                    device: data.device_details,
                    loop_type:data.loop_type
                }
            },
            // Mapper到详情页快照数据的指定格式
            accidentValueMapper(data, node,type) {
                let snapshot = data.results[0].series;
                // console.log(snapshot);
                if (snapshot) {
                    let temps = snapshot.map(item => {
                        // console.log(item,'我是item')
                        return [item.tags.node, item.values[0][1]];
                    });
                    let map = new Map(temps);
                    return this.accidentValueFormat(map, node,type);
                } else {
                    return []
                }

            },
            // Mapper表格数据
            dataMapper(data) {
                return [data.records.map(item => {
                        return {
                            name: item.loop_name || item.device_name,
                            deviceName: item.device_name,
                            position: item.area_name,
                            code: item.id,
                            classify: item.alarm_event_type,
                            type: item.event_name,
                            eventName: item.event_name || item.alarm_type_desc,
                            start: item.start_time,
                            end: item.end_time,
                            description: item.alarm_type_desc,
                            check: item.alarm_check,
                        }
                    }),
                    data.total
                ]
            },
            // 快照数据的指定格式
            accidentValueFormat(map, node,type) {
                // console.log(node)
                if(type.classify=='TELEMETRY_OVERRUN'&&type.loop_type=='TRANSFORMER'){
                    return [{
                            title: '温度',
                            unit: '℃',
                            isDangerous: ['Temperature_A', 'Temperature_B', 'Temperature_C'].includes(node),
                            value: [{
                                    name: 'A',
                                    value: map.get('Temperature_A')?map.get('Temperature_A').toFixed(2):map.get('Temperature_A'),
                                    isDangerous: ['Temperature_A'].includes(node),
                                },
                                {
                                    name: 'B',
                                    value: map.get('Temperature_B')?map.get('Temperature_B').toFixed(2):map.get('Temperature_B'),
                                    isDangerous: ['Temperature_B'].includes(node),
                                },
                                {
                                    name: 'C',
                                    value: map.get('Temperature_C')?map.get('Temperature_C').toFixed(2):map.get('Temperature_C'),
                                    isDangerous: ['Temperature_C'].includes(node),
                                },
                                // {name: '均', value: map.get('Vvavg')},
                            ]
                        }, {
                            title: '风机状态',

                            isDangerous: [this.fengji].includes(node),

                            value: [{
                                isDangerous: [this.fengji].includes(node),
                                value: map.get(this.fengji)
                            }]
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '负载',
                            unit: 'V',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: ['P'].includes(node),
                                value: (map.get('P') / 1000).toFixed(2)
                            }, ]
                        }, {
                            title: '负载率',
                            unit: '%',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: this.fengji.includes(node),
                                value: map.get(this.fengji)?map.get(this.fengji).toFixed(2):map.get(this.fengji)
                            }, ]
                        },
                        {
                            title: '容量',
                            unit: 'kVA',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: this.fengji.includes(node),

                            }, ]
                        }
                    ]   
                }else{
                    return [{
                        title: '三相相电压',
                        unit: 'V',
                        isDangerous: ['Ua', 'Ub', 'Uc', 'Vvavg'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('Ua')?map.get('Ua').toFixed(2):map.get('Ua')
                            },
                            {
                                name: 'B',
                                value: map.get('Ub')?map.get('Ub').toFixed(2):map.get('Ub')
                            },
                            {
                                name: 'C',
                                value: map.get('Uc')?map.get('Uc').toFixed(2):map.get('Uc')
                            },
                            // {name: '均', value: map.get('Vvavg')},
                        ]
                    }, {
                        title: '三相线电压',
                        unit: 'V',
                        isDangerous: ['Uab', 'Ubc', 'Uac', 'Vlavg'].includes(node),
                        value: [{
                                name: 'AB',
                                value: map.get('Uab')?map.get('Uab').toFixed(2):map.get('Uab')
                            },
                            {
                                name: 'BC',
                                value: map.get('Ubc')?map.get('Ubc').toFixed(2):map.get('Ubc')
                            },
                            {
                                name: 'AC',
                                value: map.get('Uac')?map.get('Uac').toFixed(2):map.get('Uac')
                            },
                            // {name: '均', value: map.get('Vlavg')},
                        ]
                    }, {
                        title: '电流',
                        unit: 'A',
                        isDangerous: ['Ia', 'Ib', 'Ic', 'Iavg'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('Ia')?map.get('Ia').toFixed(2):map.get('Ia')
                            },
                            {
                                name: 'B',
                                value: map.get('Ib')?map.get('Ib').toFixed(2):map.get('Ib')
                            },
                            {
                                name: 'C',
                                value: map.get('Ic')?map.get('Ic').toFixed(2):map.get('Ic')
                            },
                            // {name: '均', value: map.get('Iavg')},
                        ]
                    }, {
                        title: '有功功率',
                        unit: 'W',
                        isDangerous: ['PAa', 'PAb', 'PAc', 'PA'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('PAa')?map.get('PAa').toFixed(2):map.get('PAa')
                            },
                            {
                                name: 'B',
                                value: map.get('PAb')?map.get('PAb').toFixed(2):map.get('PAb')
                            },
                            {
                                name: 'C',
                                value: map.get('PAc')?map.get('PAc').toFixed(2):map.get('PAc')
                            },
                            // {name: '总', value: map.get('PA')}
                        ]
                    }, {
                        title: '无功功率',
                        unit: 'W',
                        isDangerous: ['PRa', 'PRb', 'PRc', 'PR'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('PRa')?map.get('PRa').toFixed(2):map.get('PRa')
                            },
                            {
                                name: 'B',
                                value: map.get('PRb')?map.get('PRb').toFixed(2):map.get('PRb')
                            },
                            {
                                name: 'C',
                                value: map.get('PRc')?map.get('PRc').toFixed(2):map.get('PRc')
                            },
                            // {name: '总', value: map.get('PR')},
                        ]
                    }, {
                        title: '温度',
                        unit: '℃',
                        isDangerous: ['Temperature'].includes(node),
                        value: [{
                            name: 'T',
                            value: map.get('Temperature')
                        }, ]
                    }, {
                        title: '频率',
                        unit: 'Hz',
                        isDangerous: ['F'].includes(node),
                        value: [{
                            name: 'F',
                            value: map.get('F')
                        }, ]
                    }]
                }
             },

            // 获取当前报警类型下首页的数据
            async getData() {
                //console.log(this.classify, this.types[0]);
                this.currentPage = 1;
                this.tableInitStatus = 'loading';
                let result = await GetDetailList({
                    areaId: this.areaId,
                    eventClass: this.classify,
                    page: 1,
                    size: 20,
                    type: this.eventType,
                    start: this.start,
                    end: this.end,
                });
                result = this.transformForData(result);
                // console.log(result)
                if (result.alarms === null) {
                    this.tableInitStatus = 'error';
                    return;
                }
                this.tableInitStatus = 'loaded';
                this.accidentStatusMore = 'loaded';
                //console.log(result.alarms)
                let out = this.dataMapper(result.alarms);
                if (result.alarms.records.length > 0 && result.alarms.total <= 20) {
                    this.accidentStatusMore = 'noMore';
                }
                return out;
            },
            // 获取报警详情数
            async getAccidentDetail(id) {
                // console.log(id)
                let result = await Promise.all([GetAccidentDetailForId(id), GetAccidentValue(id)]);
                // console.log(result, GetAccidentValue(id));

                let result0 = this.transformForData(result[0]);
                let result1 = this.transformForData(result[1]);
                // console.log(result0, result1)
                if (result0.details === null || result1.snapshot === null) {
                    return;
                }
                result0.details = this.accidentDetailMapper(result0.details)
                result1.snapshot = this.accidentValueMapper(result1.snapshot, result0.details.node,result0.details).filter((
                    item) => {
                    let obj = JSON.parse(result0.details.device)
                    if (item.title == '风机状态') {
                        if (item.value[0].value == 0) {
                            item.value[0].value = '关闭'

                        } else if (item.value[0].value > 0) {
                            item.value[0].value = '开启'
                        }
                    } else if (item.title == '负载') {

                        if (fzl == 0 || rl == 0) {
                            this.all = 0
                        } else {
                            var fzl = item.value[0].value
                            var rl = obj.电气.容量.split('k')
                            this.all = fzl / rl[0] * 100
                            // console.log(fzl, rl[0])
                        }
                        // console.log(this.all)
                    } else if (item.title == '容量') {
                        item.value[0].value = obj.电气.容量.split('kVA')[0]
                    } else if (item.title == '负载率') {
                        // console.log(this.all)
                        item.value[0].value = this.all?this.all.toFixed(2):this.all
                    }


                    return item
                });

                // console.log(result0.details, result1.snapshot)
                return {
                    infomation: result0.details,
                    data: result1.snapshot
                };
            },
            // 滚动加载更多数据
            async loadMore() {
                this.accidentStatusMore = 'loading';
                this.currentPage++;
                //console.log(this.types, this.eventType,this.types[this.eventType]);
                let result = await GetDetailList({
                    type: this.eventType,
                    eventClass: this.classify,
                    page: this.currentPage,
                    size: 20,
                    areaId: this.areaId,
                    start: this.start,
                    end: this.end,
                });
                result = this.transformForData(result);
                if (result === null) {
                    return;
                }
                //console.log('==>',result);
                let resultMapper = this.dataMapper(result.alarms);
                this.data = arrayUnique([...this.data, ...resultMapper[0]], 'code')
                // no more  不能使用当前页数据小于size来判断, 因为正好的时候会将状态置为loaded导致无限请求.
                if (this.currentPage >= result.alarms.pages) {
                    this.accidentStatusMore = 'noMore';
                } else {
                    this.accidentStatusMore = 'loaded';
                }
            },
        },
        computed: {
            fengji: function () {

                if (this.$store.state.project.currentProject.projectId == 4) {
                    return "Temperature_status_windopen"
                    //  console.log(value)
                } else {
                    return "Fan_Status"
                    //  console.log(value)
                }
            },
            // 获取项目Id
            projectId: function () {
                return this.$store.getters.projectId;
            },
            // 获取报警种类
            classify: function () {
                return this.$route.params.classify;
            },
            // 获取报警类型
            types: function () {
                //console.log(this.classify);
                return ALARM_TYPE[this.classify]
            },
            //合并多种改变, watch它重新获取数据
            reload: function () {
                return {
                    start: this.start,
                    end: this.end,
                    eventType: this.eventType,
                    areaId: this.areaId,
                    classify: this.classify,
                }
            }
        },
        watch: {
            // 重新获取数据
            reload: async function (val, oldVal) {
                // 先清除可以防止切换后自动加载多页数据
                this.data = [];
                this.tatal = 0;
                let data = await this.getData();
                this.data = data[0];
                // console.log(this.data)
                this.total = data[1];
            },
            // 种类变更时清除选择的事件类型
            classify: function () {
                this.eventType = '';
            }
        }
    }
</script>

<style lang="less" scoped>
    .body {
        display: flex;
        flex-direction: column;
        height: 100%;
        background: #fff;

        .table {
            flex: 1;
            overflow: hidden;
            //火狐隐藏滚动条
            scrollbar-width: none;

            ::-webkit-scrollbar {
                display: none;
            }
        }
    }
</style>